import React from "react";
import { useTranslation } from "react-i18next";
import { Email, Whatsapp } from "@components/icons/icons";

const ContactCard = ({ imageSrc }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col sm:flex-row lg:flex-col w-full lg:min-w-[19rem] xl:min-w-[24rem] h-fit bg-white rounded-[1.25rem] border border-gray-200 shadow-md self-start">
      <div className="rounded-t-[1.25rem] sm:w-2/3 lg:w-full">
        <img
          className="rounded-t-[1.25rem] sm:rounded-t-none sm:rounded-l-[1.25rem] lg:rounded-l-none lg:rounded-t-[1.25rem] w-full sm:h-full lg:h-auto object-cover object-center"
          src={imageSrc}
          alt="contact Moverii"
          loading="lazy"
        />
      </div>
      <div>
        <div className="p-4">
          <p className="text-[#2B2D42] text-base">
            {t("moverii_contact_information_desc")}
          </p>
        </div>

        {/* Mail */}
        <div className="py-4 pt-2 px-5 flex flex-col gap-3">
          <div className="flex flex-col">
            <a
              href={`mailto:team@moverii.de`}
              className="flex items-center text-[1.12rem]"
            >
              <span className="pr-2">
                <Email />
              </span>
              <p className="!text-base hover:text-[#12a3ba] cursor-pointer">
                team@moverii.de
              </p>
            </a>
          </div>

          {/* WhatsApp */}
          <div className="flex flex-col">
            <a
              href={"https://wa.me/491632220021"}
              target={"_blank"}
              className="flex items-center text-[1.12rem]"
            >
              <span className="pr-2">
                <Whatsapp />
              </span>
              <p className="!text-base hover:text-[#12a3ba] cursor-pointer">
                +491632220021
              </p>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
